<template>
  <v-data-table
    :value="selected"
    :headers="columns"
    :items="users"
    :options.sync="tableOptions"
    :server-items-length="total"
    item-key="userId"
    show-select
    :items-per-page="itemsPerPage"
    :footer-props="footerProps"
    class="elevation-0"
    :class="{
      'cursor-pointer': clickableRows,
    }"
    :loading="loading"
    :search="search"
    :sortable="false"
    loading-text="Loading... Please wait"
    no-data-text="No people found"
    no-results-text="No people found in search"
    @click:row="handleRowClick"
    @input="$emit('update:selected', $event)"
  >
    <template v-slot:[`item.profilePicUrl`]="{ item }">
      <div class="profile-pic-container d-flex justify-center">
        <v-img
          v-bind:src="item.profilePicUrl"
          v-if="item && item.profilePicUrl"
          height="35"
          width="35"
          max-height="35"
          max-width="35"
          class="rounded-circle profile-picture"
        />
        <v-icon v-else class="profile-picture rounded-circle icon-image">mdi-account</v-icon>
      </div>
    </template>
    <template v-slot:[`item.tableDisplayName`]="{ item }">
      <span class="word-break">{{ item?.tableDisplayName || "" }}</span>
      <br />
      <span class="mediumGrey--text word-break">{{
        item?.businessEmail || item?.businessPhone || ""
      }}</span>
    </template>
    <template v-slot:[`item.organization`]="{ item }">
      <span class="word-break">{{ item?.organization || "" }}</span>
      <br />
      <span class="mediumGrey--text">{{ item?.jobTitle || "" }}</span>
    </template>
    <template v-slot:[`item.data-table-select`]="{ item }">
      <v-simple-checkbox
        color="darkGrey"
        class="py-0 my-0"
        hide-details
        :ripple="false"
        @click.stop="handleCheckboxClick(item)"
        :value="!!selected.find((x) => item && x.userId == item.userId)"
      />
    </template>
    <template v-slot:[`item.externalUser`]="{ item }">
      <v-icon v-if="item.externalUser">mdi-check</v-icon>
    </template>
    <template v-slot:[`item.balance`]="{ item }">
      <span
        v-if="isPointsOnlyClient && item.pointBalance !== undefined && item.pointBalance !== null"
        class="font-weight-medium balance-text"
      >
        {{ item.pointBalance }} {{ Number(item.pointBalance) === 1 ? "pt" : "pts" }}
      </span>
      <span
        v-else-if="item.balance !== undefined && item.balance !== null"
        class="font-weight-medium balance-text"
      >
        ${{ item.balance }}
      </span>
    </template>
    <template v-slot:[`item.wallet`]="{ item }">
      <v-btn icon @click.stop="handleWalletClick(item)">
        <v-icon>mdi-credit-card</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "UserDataTable",
  props: {
    selected: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Array,
      default: () => [],
    },
    isPointsOnlyClient: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    total: {
      type: Number,
      default: 0,
    },
    itemsPerPage: {
      type: Number,
      default: 10,
    },
    footerProps: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
    search: {
      type: String,
      default: "",
    },
    clickableRows: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableOptions: {
      get() {
        return this.options;
      },
      set(value) {
        this.$emit("update:options", value);
      },
    },
  },
  methods: {
    handleRowClick(item) {
      if (!this.clickableRows) return;
      this.$emit("row-click", item);
    },
    handleCheckboxClick(item) {
      this.$emit("checkbox-click", item);
    },
    handleWalletClick(item) {
      this.$emit("wallet-click", item);
    },
  },
};
</script>

<style scoped>
.word-break {
  word-break: break-word;
}
.balance-text {
  white-space: nowrap;
}
.cursor-pointer {
  cursor: pointer;
}
.profile-pic-container {
  width: 35px;
}
.profile-picture {
  border: 1px solid #e0e0e0;
}
.icon-image {
  background-color: #f5f5f5;
  height: 35px;
  width: 35px;
}
</style>
